import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const remunerationTypeOptions = [
  {id: 'annually', name: '年俸'},
  {id: 'monthly', name: '月給'},
  {id: 'daily', name: '日給'},
  {id: 'hourly', name: '時給'},
]

export const RemunerationTypes: FC = () => {
  return (
    <MultiTagFilteringFieldRow
      header="給与形態"
      name="remunerationTypes"
      list={withNull(remunerationTypeOptions)}
      shouldUnregister
    />
  )
}
